import useSWR from 'swr';
export const useGeoStats = (datasetId: string, tableId: string) => {
  return useSWR(`/api/dataset/${datasetId}/table/${tableId}/table-stats/geo-stats`);
};